import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import SwipeableDrawer from '@material-ui/core/SwipeableDrawer';
import { createComponent as cc } from 'react-fela';
import LinkWithoutDecoration from '../wrappers/LinkWithoutDecoration';

const ListWrapper = cc(() => ({
  width: '250px',
}));

@inject('store')
@observer
class DashBoardSidebar extends Component {
  constructor(props) {
    super(props);
    this.dashBoardStore = props.store.dashBoardStore;
    this.apiStore = props.store.apiStore;
    this.feedBotStore = props.store.feedBotStore;
  }

  toggleDrawer = open => () => {
    this.dashBoardStore.setSidebarOpen(open);
  };

  handleSignOutClick = () => {
    this.apiStore.signOut().then(() => {
      this.dashBoardStore.resetDashBoardStore();
      this.feedBotStore.resetfeedBotStore();
    });
  };

  render() {
    const { sidebarOpen } = this.dashBoardStore;
    return (
      <div>
        <SwipeableDrawer
          open={sidebarOpen}
          onClose={this.toggleDrawer(false)}
          onOpen={this.toggleDrawer(true)}
          onClick={this.toggleDrawer(false)}
          anchor="left"
        >
          <ListWrapper tabIndex={0} role="button">
            <List component="nav">
              <LinkWithoutDecoration to="/">
                <ListItem>
                  <ListItemText primary="Dashboard" />
                </ListItem>
              </LinkWithoutDecoration>

              <LinkWithoutDecoration to="/users">
                <ListItem>
                  <ListItemText primary="Users" />
                </ListItem>
              </LinkWithoutDecoration>

              <ListItem onClick={this.handleSignOutClick}>
                <ListItemText primary="Logout" />
              </ListItem>
            </List>
          </ListWrapper>
        </SwipeableDrawer>
      </div>
    );
  }
}

export default DashBoardSidebar;



// WEBPACK FOOTER //
// ./src/components/home/DashBoardSidebar.js